import React, {Component} from 'react';
import PropTypes from 'prop-types';

import { Container, Row, Col } from 'react-bootstrap';
import { MDBIcon } from 'mdbreact';
import { Paper, Tabs, Tab, Typography, Box, Grid} from '@material-ui/core';

import RecordAdd from './recordAdd'
import BankBalance from './bankBalance'

import IncomesExpensesLine from '../charts/line/incomesExpenses'
import Category from '../charts/pie/category'

export default class Financial extends Component {

    constructor(){
        super()
        this.state={
            value: 0
        }
    }

    handleChange = (event, newValue) => {
        this.setState({value: newValue});
    };

    render() {
        return (
          <>
            <Container>
                <Row className="TitleContainer">
                <Col style={{ padding: "10px"}}>
                    <h4><MDBIcon icon="donate" className="mr-2 ml-4" />Finanças</h4>
                </Col>
                <Col>
                    <RecordAdd />
                </Col>
              </Row>
            </Container>
            <Container className="MainContainer" style={{ backgroundColor: 'white', padding: '5px' }} >
                <Row>
                    <Col>
                        <Paper position="static" square>
                          <Tabs
                            value={this.state.value}
                            onChange={this.handleChange}
                            aria-label="simple tabs example"
                            variant="scrollable"
                          >
                            <Tab label="DashBoard" {...a11yProps(0)} />
                            <Tab label="Saldos" {...a11yProps(1)} />
                            <Tab label="Provisões" {...a11yProps(2)} />
                          </Tabs>
                        </Paper>
                        <TabPanel value={this.state.value} index={0}>
                            <Grid
                              container
                              spacing={3}
                              direction="row"
                              justify="center"
                              alignItems="center"
                            >
                                <Grid item xs={12} md={6}>
                                  <IncomesExpensesLine />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                  <Category />
                                </Grid>
                            </Grid>

                        </TabPanel>
                        <TabPanel value={this.state.value} index={1}>
                            <BankBalance />
                        </TabPanel>
                        <TabPanel value={this.state.value} index={2}>
                            Provisões
                        </TabPanel>
                    </Col>
                </Row>
            </Container>
          </>
        );
      }
  }

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}
